import { render, staticRenderFns } from "./LpPropTab.vue?vue&type=template&id=13e00cad&scoped=true"
import script from "./LpPropTab.vue?vue&type=script&lang=js"
export * from "./LpPropTab.vue?vue&type=script&lang=js"
import style0 from "./LpPropTab.vue?vue&type=style&index=0&id=13e00cad&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e00cad",
  null
  
)

export default component.exports